import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import {
  AdminEditProfileData,
  AdminEditPoliciesData,
  AdminEditInvoicesData,
  AdminEditDamagesData,
  AdminEditLogsData,
  AdminEditBasicData,
} from '.';

export const AdminEditRouting = ({ user, baseRoute, isEmployee }) => {
  return (
    <Switch>
      <Route exact path={`${baseRoute}/:id/profile`} render={() => <AdminEditProfileData user={user} />} />
      <Route exact path={`${baseRoute}/:id/policies`} render={() => <AdminEditPoliciesData user={user} />} />
      <Route exact path={`${baseRoute}/:id/invoices`} render={() => <AdminEditInvoicesData user={user} />} />
      <Route exact path={`${baseRoute}/:id/damage-claims`} render={() => <AdminEditDamagesData user={user} />} />
      <Route
        exact
        path={`${baseRoute}/:id/logs`}
        render={() => <AdminEditLogsData user={user} isEmployee={isEmployee} />}
      />
      <Route exact path={`${baseRoute}/:id`} render={() => <AdminEditBasicData user={user} />} />
      <Redirect to={`${baseRoute}/${user.id}`} />
    </Switch>
  );
};
